/* Shared product-thumbnail behavior: owned check, wishlist heart, add-to-cart.
   Markup: snippets/product-thumb-overlay.liquid. States come from one
   GET /product-states call per page (cached), fetched lazily — on load for
   visible thumbnails, or when window.pthumbRefresh() is called (e.g. a dialog opening). */
(function () {
  if (window.pthumbRefresh) return;

  var config = null;
  var statesPromise = null;
  var states = { owned: {}, wishlist: {} };

  function getConfig() {
    if (!config) config = document.querySelector('[data-pthumb-config]');
    return config;
  }

  function numericId(gid) {
    return String(gid).replace(/\D/g, '');
  }

  function loadStates() {
    var cfg = getConfig();
    if (!cfg || !cfg.dataset.viewerEmail || !cfg.dataset.apiBase) return Promise.resolve();
    if (!statesPromise) {
      statesPromise = fetch(cfg.dataset.apiBase + '/product-states?' + new URLSearchParams({ email: cfg.dataset.viewerEmail }))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          (data.owned_ids || []).forEach(function (id) { states.owned[numericId(id)] = true; });
          (data.wishlist_ids || []).forEach(function (id) { states.wishlist[numericId(id)] = true; });
        })
        .catch(function () {});
    }
    return statesPromise;
  }

  function addOwnedBadge(el) {
    if (el.querySelector('.pthumb-owned')) return;
    var ns = 'http://www.w3.org/2000/svg';
    var badge = document.createElement('span');
    badge.className = 'pthumb-owned';
    badge.setAttribute('aria-label', 'You already own this');
    var svg = document.createElementNS(ns, 'svg');
    ['viewBox:0 0 24 24', 'width:12', 'height:12', 'fill:none', 'stroke:currentColor', 'stroke-width:3',
     'stroke-linecap:round', 'stroke-linejoin:round', 'aria-hidden:true'].forEach(function (pair) {
      var i = pair.indexOf(':');
      svg.setAttribute(pair.slice(0, i), pair.slice(i + 1));
    });
    var poly = document.createElementNS(ns, 'polyline');
    poly.setAttribute('points', '20 6 9 17 4 12');
    svg.appendChild(poly);
    badge.appendChild(svg);
    // Product cards stack it with the heart/SPC tab (see product-block.liquid).
    (el.querySelector('.pcard-badges__stack') || el).appendChild(badge);
  }

  function applyWishlist(el) {
    var btn = el.querySelector('[data-pthumb-wishlist]');
    if (!btn) return;
    var on = !!states.wishlist[el.dataset.productId];
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = on ? 'Remove from wishlist' : 'Add to wishlist';
    btn.setAttribute('aria-label', label);
    if (btn.hasAttribute('data-tooltip')) btn.setAttribute('data-tooltip', label);
  }

  function refresh() {
    var els = document.querySelectorAll('[data-pthumb]');
    if (!els.length) return;
    loadStates().then(function () {
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (states.owned[el.dataset.productId]) addOwnedBadge(el);
        applyWishlist(el);
      }
    });
  }

  function toggleWishlist(btn) {
    var el = btn.closest('[data-pthumb]');
    var cfg = getConfig();
    if (!el || !cfg || !cfg.dataset.viewerEmail || btn.disabled) return;
    var adding = !states.wishlist[el.dataset.productId];
    states.wishlist[el.dataset.productId] = adding;
    applyWishlist(el);
    btn.disabled = true;
    fetch(cfg.dataset.apiBase + '/wishlist/set', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: cfg.dataset.viewerEmail,
        product_id: el.dataset.productId,
        variant_id: el.dataset.wishlistVariantId || el.dataset.variantId,
        in_wishlist: adding
      })
    }).then(function (r) { if (!r.ok) throw new Error('failed'); })
      .catch(function () { states.wishlist[el.dataset.productId] = !adding; })
      .then(function () {
        btn.disabled = false;
        // Every thumbnail of the same product on the page stays in sync.
        document.querySelectorAll('[data-pthumb]').forEach(applyWishlist);
      });
  }

  function addToCart(btn) {
    var el = btn.closest('[data-pthumb]');
    if (!el || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    // Multi-variant products need a choice — send to the product page.
    if (el.dataset.needsOptions === 'true' || !el.dataset.variantId) {
      window.location.href = '/products/' + el.dataset.handle;
      return;
    }
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(el.dataset.variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('failed');
      btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function () {})
      .then(function () {
        setTimeout(function () { btn.classList.remove('is-added'); btn.disabled = false; }, 2000);
      });
  }

  document.addEventListener('click', function (event) {
    var w = event.target.closest('[data-pthumb-wishlist]');
    if (w) { event.preventDefault(); toggleWishlist(w); return; }
    var c = event.target.closest('[data-pthumb-cart]');
    if (c) { event.preventDefault(); addToCart(c); }
  });

  window.pthumbRefresh = refresh;
  // Skip thumbnails inside closed dialogs on load; they refresh when opened.
  document.addEventListener('DOMContentLoaded', function () {
    var anyVisible = Array.prototype.some.call(document.querySelectorAll('[data-pthumb]'), function (el) {
      return !el.closest('dialog:not([open])');
    });
    if (anyVisible) refresh();
  });
})();
